import Modal from '../Modal/Modal'
import './AboutModal.css'

const AboutModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="⚔️ About Unity-BOT">
      <div className="about">
        {/* Unity-BOT Section */}
        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/logo-128x128.svg" alt="Unity-BOT" className="about__bot-icon" />
            Unity-BOT v3.0 BETA
          </h3>
          <p className="about__text">
            <strong>Unity-BOT</strong> is a sophisticated automation tool specifically engineered for 
            TibiaME, representing years of development and community feedback. Built with precision 
            and efficiency, it transforms the way players experience the game by automating tedious 
            tasks while maintaining the highest standards of safety and performance.
          </p>
          
          <h4 className="about__feature-title">🎯 Core Features</h4>
          <ul className="about__list">
            <li><strong>Smart Auto-Hunting</strong> - Advanced pathfinding system with customizable routes, 
            creature priority selection, loot collection, and automatic backpack management</li>
            <li><strong>Intelligent Auto-Heal</strong> - Predictive healing algorithm that monitors HP/MP 
            in real-time, with configurable thresholds and emergency failsafes</li>
            <li><strong>Quest Automation</strong> - Complete quest workflows including NPC dialogues, 
            item delivery, and multi-step mission execution</li>
            <li><strong>Auto-Skills Training</strong> - Optimize skill progression with automated training 
            routines for melee, distance, and magic skills</li>
          </ul>

          <h4 className="about__feature-title">⚙️ Advanced Capabilities</h4>
          <ul className="about__list">
            <li><strong>Action Scripting System</strong> - Create custom sequences: use items, talk to NPCs, 
            navigate coordinates, and chain multiple actions with conditional logic</li>
            <li><strong>Auto-Checker System</strong> - Real-time monitoring with configurable alerts for 
            HP, MP, capacity, creature detection, and custom triggers</li>
            <li><strong>Anti-Detection Technology</strong> - Human-like behavior patterns, randomized 
            delays, and smart response times to maintain natural gameplay</li>
            <li><strong>Resource Optimization</strong> - Ultra-lightweight design (&lt; 50MB RAM usage), 
            minimal CPU footprint, and efficient network handling</li>
          </ul>

          <h4 className="about__feature-title">🛡️ Safety & Performance</h4>
          <ul className="about__list">
            <li>✅ No memory injection - operates through screen capture and input simulation</li>
            <li>✅ Multi-layered failsafe systems to prevent character death</li>
            <li>✅ Built-in anti-stuck mechanisms and error recovery</li>
            <li>✅ Real-time statistics dashboard with session tracking</li>
            <li>✅ Regular updates and bug fixes from active development team</li>
          </ul>

          <h4 className="about__feature-title">👥 Community & Support</h4>
          <p className="about__text">
            Join thousands of players in our thriving community. Access comprehensive guides, 
            share custom scripts, get technical support, and contribute to the bot's evolution. 
            Our Discord server is active 24/7 with experienced users and developers ready to help.
          </p>
        </section>

        {/* Divider */}
        <div className="about__divider">⚜️</div>

        {/* TibiaME Section */}
        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/tibiame_logo.png" alt="TibiaME" className="about__game-icon" />
            TibiaME
          </h3>
          <p className="about__text">
            <strong>TibiaME</strong> (Tibia Micro Edition) is the first massively multiplayer 
            MMORPG for mobile devices, released in 2003. Based on the classic
            <em> Tibia</em>, the game allows hundreds of players to connect 
            simultaneously to explore a colorful virtual world.
          </p>
          <p className="about__text">
            In the game, you can explore mysterious lands, fight against hordes of evil 
            creatures, solve ancient puzzles, find hidden treasures and grow in 
            strength and power with each monster defeated.
          </p>
          <p className="about__text about__highlight">
            📱 Available for iOS and Android
          </p>
        </section>

        {/* Divider */}
        <div className="about__divider">⚜️</div>

        {/* CipSoft Section */}
        <section className="about__section">
          <h3 className="about__subtitle">
            <img src="/assets/Logo_CipSoft.png" alt="CipSoft" className="about__company-icon" />
            CipSoft GmbH
          </h3>
          <p className="about__text">
            <strong>CipSoft</strong> is an independent German online game developer, 
            founded after the success of <em>Tibia</em> - one of the first MMORPGs in history, 
            online since 1997. The company has over 100 employees and is internationally 
            recognized.
          </p>
          <ul className="about__list">
            <li>🎮 <strong>Tibia</strong> (1997) - Classic browser MMORPG</li>
            <li>📱 <strong>TibiaME</strong> (2003) - First mobile MMORPG</li>
            <li>🏰 <strong>The Settlers Online</strong> - Strategy game</li>
            <li>🧟 <strong>Persist Online</strong> - New zombie MMORPG (in development)</li>
          </ul>
          <p className="about__text about__award">
            🏆 Winner of German Developer Award 2019 for Tibia
          </p>
        </section>

        {/* Divider */}
        <div className="about__divider">⚜️</div>

        {/* Disclaimer */}
        <section className="about__section about__disclaimer">
          <h3 className="about__subtitle">⚠️ Legal Notice</h3>
          <p className="about__text">
            Unity-BOT is an independent project and <strong>is not affiliated, endorsed or 
            sponsored by CipSoft GmbH</strong>. TibiaME and Tibia are registered trademarks 
            of CipSoft GmbH.
          </p>
          <p className="about__text">
            The use of automation tools may violate the game's Terms of Service. 
            <strong> Use at your own risk.</strong>
          </p>
        </section>

        {/* Version */}
        <div className="about__version">
          <span>Unity-BOT v3.0 BETA</span>
          <span>© 2026 Unity-BOT Team</span>
        </div>
      </div>
    </Modal>
  )
}

export default AboutModal
